"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const property_1 = require("@genesys/property");
const calculations_1 = require("@munters/calculations/");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const fan_performance_results_1 = require("./fan-pro-results/fan-performance-results");
const KnownProperties = __importStar(require("./known-properties"));
const initialState = {
    input: getInitalProperties(),
    fanCurvePoints: getInitialFanCurvePoints(),
    results: undefined,
    isLoading: false
};
function reducer(
// biome-ignore lint: -
state = initialState, action) {
    switch (action.type) {
        case "fan-motor-pro-tool/SET-PROPERTIES-FROM-FILE": {
            // Apply fixes.
            const pvsesFromFile = action.payload.pvses.map(applyUpdates);
            // Add the coefficients defaults not saved/loaded.
            pvsesFromFile[0] = property_1.PropertyValueSet.merge(pvsesFromFile[0], initialState.input);
            const pvsDensity = updateDensity(pvsesFromFile[0]);
            return Object.assign(Object.assign({}, state), { input: pvsDensity, fanCurvePoints: pvsToFanCurvePoints(pvsDensity), results: undefined });
        }
        case "fan-motor-pro-tool/SET-PROPERTIES-AIR-IN": {
            const pvs = action.payload;
            const temperature = property_1.PropertyValueSet.getAmount("airinputstemperature", pvs);
            const relativehumidity = property_1.PropertyValueSet.getAmount("airinputshumidity", pvs);
            const pressure = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
            const massflow = property_1.PropertyValueSet.getAmount("airinputsmassflow", pvs);
            let newpvs = property_1.PropertyValueSet.Empty;
            try {
                const humidityratio = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressure, temperature, relativehumidity);
                const air = calculations_1.Physics.AirFlowState.create(temperature, humidityratio, pressure, massflow);
                const actualdensity = calculations_1.Physics.AirFlowState.density(air);
                newpvs = property_1.PropertyValueSet.setAmount("actualdensity", actualdensity, pvs);
            }
            catch (_error) {
                newpvs = property_1.PropertyValueSet.removeProperty("actualdensity", pvs);
            }
            return Object.assign(Object.assign({}, state), { input: newpvs, fanCurvePoints: pvsToFanCurvePoints(newpvs), results: undefined });
        }
        case "fan-motor-pro-tool/CALCULATE-FAN":
            return Object.assign(Object.assign({}, state), { isLoading: true, results: undefined });
        case "fan-motor-pro-tool/PARSE-RESULT": {
            const results = action.result.map((r) => ({
                result: (0, fan_performance_results_1.makePvs)(r),
                errors: r.errors.map((e) => {
                    return {
                        code: e.code,
                        text: e.text
                    };
                }),
                warnings: r.warnings.map((w) => {
                    return {
                        code: w.code,
                        text: w.text
                    };
                })
            }));
            return Object.assign(Object.assign({}, state), { results: results, isLoading: false });
        }
        case "fan-motor-pro-tool/ADD-FAN-CURVE-POINT":
            return Object.assign(Object.assign({}, state), { fanCurvePoints: state.fanCurvePoints.concat(Object.assign({}, state.fanCurvePoints[state.fanCurvePoints.length - 1])), results: undefined });
        case "fan-motor-pro-tool/DELETE-FAN-CURVE-POINT":
            return Object.assign(Object.assign({}, state), { fanCurvePoints: state.fanCurvePoints.slice(0, state.fanCurvePoints.length - 1), results: undefined });
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
function applyUpdates(pvs) {
    return property_1.PropertyValueSet.merge(pvs, property_1.PropertyValueSet.Empty);
}
function updateDensity(pvs) {
    const temperature = property_1.PropertyValueSet.getAmount("airinputstemperature", pvs);
    const relativehumidity = property_1.PropertyValueSet.getAmount("airinputshumidity", pvs);
    const pressure = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
    const massflow = property_1.PropertyValueSet.getAmount("airinputsmassflow", pvs);
    const humidityratio = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressure, temperature, relativehumidity);
    const air = calculations_1.Physics.AirFlowState.create(temperature, humidityratio, pressure, massflow);
    const actualdensity = calculations_1.Physics.AirFlowState.density(air);
    const newpvs = property_1.PropertyValueSet.setAmount("actualdensity", actualdensity, pvs);
    return newpvs;
}
function getInitalProperties() {
    const initialState = property_1.PropertyValueSet.fromString(`${KnownProperties.airInputsTemperature}=25:Celsius;` +
        `${KnownProperties.airInputsHumidity}=50.0:PercentHumidity;` +
        `${KnownProperties.airInputsMassflow}=1500:StandardCubicMeterPerHour;` +
        `${KnownProperties.airInputsPressure}=100.389:KiloPascal;` +
        `${KnownProperties.targetPressure}=864:Pascal;` +
        `${KnownProperties.altitude}=0:Meter;` +
        `${KnownProperties.actualDensity}=1.2:KilogramPerCubicMeter;` +
        `${KnownProperties.fanControlMode}=1;` +
        `${KnownProperties.fanQuantity}=1:One;` +
        `${KnownProperties.fanDefinitionSpeed}=1400:RevolutionsPerMinute;` +
        `${KnownProperties.fanDefinitionStandardDensity}=1.16:KilogramPerCubicMeter;` +
        `${KnownProperties.fanOutletArea}=0.056:SquareMeter;` +
        `${KnownProperties.fanDynamicPressureLossCoefficient}=0:One;` +
        `${KnownProperties.fanMinimumSpeed}=200:RevolutionsPerMinute;` +
        `${KnownProperties.fanMaximumSpeed}=1600:RevolutionsPerMinute;` +
        `${KnownProperties.motorNominalPower}=1.7:KiloWatt;` +
        `${KnownProperties.motorPoles}=4:One;` +
        `${KnownProperties.motorEfficiency}=73:Percent;` +
        `${KnownProperties.motorBaseFrequency}=50:Hertz;` +
        `${KnownProperties.motorNominalSpeed}=1200:RevolutionsPerMinute;` +
        `${KnownProperties.motorMinimumSpeed}=200:RevolutionsPerMinute;` +
        `${KnownProperties.motorMaximumSpeed}=1600:RevolutionsPerMinute;` +
        `${KnownProperties.motorLag}=1:Percent;` +
        `${KnownProperties.motorVoltage}=400:Volt;` +
        `${KnownProperties.motorPhases}=3:One;` +
        `${KnownProperties.motorCosphi}=0.92:One;` +
        `${KnownProperties.motorOverspeedDerateFactor}=5:Percent;` +
        `${KnownProperties.driveType}=1;` +
        `${KnownProperties.driveEfficiency}=85:Percent;` +
        `${KnownProperties.driveRatio}=0:One;` +
        `${KnownProperties.inverter}=1;` +
        `${KnownProperties.inverterEfficiency}=95:Percent;`);
    const pvsDensity = updateDensity(initialState);
    return pvsDensity;
}
function getInitialFanCurvePoints() {
    return [
        property_1.PropertyValueSet.fromString("airflow=1059:CubicMeterPerHour;pressure=1605:Pascal;shaftpower=836:Watt;"),
        property_1.PropertyValueSet.fromString("airflow=1582:CubicMeterPerHour;pressure=1480:Pascal;shaftpower=978:Watt;"),
        property_1.PropertyValueSet.fromString("airflow=2104:CubicMeterPerHour;pressure=1270:Pascal;shaftpower=1045:Watt;"),
        property_1.PropertyValueSet.fromString("airflow=2627:CubicMeterPerHour;pressure=950:Pascal;shaftpower=1009:Watt;"),
        property_1.PropertyValueSet.fromString("airflow=3150:CubicMeterPerHour;pressure=475:Pascal;shaftpower=843:Watt;")
    ];
}
function pvsToFanCurvePoints(pvs) {
    let i = 1;
    let curvePoints = [];
    while (true) {
        const regEx = new RegExp("^point" + i);
        const curvePoint = property_1.PropertyValueSet.map((kvp) => ({
            key: kvp.key.replace(regEx, ""),
            value: kvp.value
        }), property_1.PropertyValueSet.filter((kvp) => regEx.test(kvp.key), pvs));
        if (!property_1.PropertyValueSet.count(curvePoint)) {
            break;
        }
        curvePoints = curvePoints.concat(curvePoint);
        i++;
    }
    return curvePoints;
}
//# sourceMappingURL=reducer.js.map